import { FormFieldSelectNG } from '../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  getFormikSelectFieldNextValue,
  getFormikSelectFieldValueProps,
} from '../../../Formik'
import { InputSelect } from '../../../Select'
import { SettingsField } from '../../../Settings'

function CalendarSettingsSelectField({ disabled, labelKey, name, options }) {
  return (
    <FormikField
      Component={FormFieldSelectNG}
      Field={SettingsField}
      Select={InputSelect}
      controlProps={{ indicatorsProps: { ButtonClear: null } }}
      disabled={disabled}
      emptyValue={null}
      fieldComponentProps={{ labelKey }}
      getErrorProps={getFormikFormFieldErrorProps}
      getNextValue={getFormikSelectFieldNextValue}
      getValueProps={getFormikSelectFieldValueProps(options)}
      name={name}
      options={options}
    />
  )
}

export default CalendarSettingsSelectField
